import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/library", label: "视频库" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/library?q=${encodeURIComponent(q)}` : "/library");
    setOpen(false);
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="瓜趣视频首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl text-primary-700">瓜趣视频</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3.5 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden items-center lg:flex" role="search">
            <div className="flex items-center overflow-hidden rounded-md border border-background-300 bg-background-100 focus-within:border-primary-400">
              <i className="ri-search-line pl-3 text-sm text-foreground-400" aria-hidden="true"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索视频..."
                aria-label="搜索视频"
                className="w-44 bg-transparent px-2 py-2 text-sm outline-none"
              />
              <button
                type="submit"
                className="whitespace-nowrap bg-primary-500 px-3.5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                搜索
              </button>
            </div>
          </form>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 md:hidden cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center" role="search">
            <div className="flex flex-1 items-center overflow-hidden rounded-md border border-background-300 bg-background-100">
              <i className="ri-search-line pl-3 text-sm text-foreground-400" aria-hidden="true"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索视频..."
                aria-label="搜索视频"
                className="w-full bg-transparent px-2 py-2 text-sm outline-none"
              />
            </div>
            <button
              type="submit"
              className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}